package id.neotica.neotica.components.layouts

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.data.getValue
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toAttrs
import id.neotica.neotica.components.NeoColor
import id.neotica.neotica.components.retro.RainbowDivider
import id.neotica.neotica.components.retro.isRetroRoute
import id.neotica.neotica.components.sections.NeoFooter
import id.neotica.neotica.components.sections.header.NeoNavHeader
import kotlinx.browser.document
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.dom.Div

class NeoLayoutData(val title: String, val route: String? = "")

@Layout
@Composable
fun NeoPageLayout(ctx: PageContext, content: @Composable () -> Unit) {
    val data = ctx.data.getValue<NeoLayoutData>()
    val retro = isRetroRoute()
    LaunchedEffect(data.title) {
        document.title = data.title
    }

    Box(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(NeoColor.backgroundPrimary)
            .gridTemplateRows { size(1.fr); size(minContent) },
        contentAlignment = Alignment.TopCenter
    )
    {

        Column(
            Modifier
                .fillMaxWidth().gridRow(1),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Box(
                modifier = Modifier.fillMaxSize().padding(leftRight = 2.cssRem)
            ) { NeoNavHeader(data.route, retro) }
            if (retro) RainbowDivider()
            Div(PageContentStyle.toAttrs()) { content() }
            if (retro) RainbowDivider()
        }
        NeoFooter(Modifier.fillMaxWidth().gridRow(2), retro)

    }
}

val PageContentStyle = CssStyle {
    base { Modifier.fillMaxSize() }
}